import { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import SidenavItem from "examples/Sidenav/SidenavItem";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { useArgonController, setMiniSidenav } from "context";
import SidenavCollapse from "./SidenavCollapse";
import SidenavChild from "./SidenavChild";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, darkSidenav, layout, darkMode } = controller;
    const location = useLocation();
    const { pathname } = location;
    const collapsezzz = pathname.split("/").slice(1)[1]
    const collapseName = collapsezzz === undefined ? "" : collapsezzz;
    const [selectedMenu, setSelectedMenu] = useState(null);

    const closeSidenav = () => setMiniSidenav(dispatch, true);

    useEffect(() => {
        function handleMiniSidenav() {
            setMiniSidenav(dispatch, window.innerWidth < 1200);
        }

        window.addEventListener("resize", handleMiniSidenav);

        handleMiniSidenav();

        return () => window.removeEventListener("resize", handleMiniSidenav);
    }, [dispatch, location]);

    const handleClickMenu = (params) => {
        selectedMenu === params ? setSelectedMenu(null) : setSelectedMenu(params)
    }

    const renderChildren = (collapse) => {

        const xx = collapse.map(({ name, key, route }) => {
            return (
                <SidenavChild
                    // color={color}
                    name={name}
                    active={key.includes(pathname)}
                    route={route}
                    key={key}
                />
            )
        })

        return <List component="div" disablePadding>{xx}</List>
    }

    const renderRoutes = routes.map(({ type, name, icon, title, key, href, route, noCollapse, collapse }) => {
        let returnValue;

        if (type === "route") {
            if (href) {
                returnValue = (
                    <Link href={href} key={key} target="_blank" rel="noreferrer">
                        <SidenavItem
                            name={name}
                            icon={icon}
                            active={key.includes(pathname)}
                            noCollapse={noCollapse}
                        />
                    </Link>
                );
            } else {
                returnValue = (
                    <NavLink to={route} key={key}>
                        <SidenavItem name={name} icon={icon} active={key.includes(pathname)} />
                    </NavLink>
                );
            }
        } else if (type === "collapse") {
            returnValue = (
                <SidenavCollapse
                    // color={darkSidenav ? "white" : "dark"}
                    key={key}
                    name={name}
                    icon={icon}
                    active={key.includes(collapseName)}
                    noCollapse={noCollapse}
                    open={selectedMenu === key}
                    onClick={(e) => handleClickMenu(key)}
                    children={collapse && renderChildren(collapse)}
                >
                </SidenavCollapse>
            )
        } else if (type === "title") {
            returnValue = (
                <ArgonTypography
                    key={key}
                    color={darkMode ? darkSidenav && "white" : darkSidenav ? "white" : "dark"}
                    display="block"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="uppercase"
                    opacity={0.6}
                    pl={3}
                    mt={2}
                    mb={1}
                    ml={1}
                >
                    {title}
                </ArgonTypography>
            );
        } else if (type === "divider") {
            returnValue = (
                <Divider
                    key={key}
                    light={darkMode ? !darkSidenav : darkSidenav}
                    // light={darkMode ? darkSidenav ? true : false: darkSidenav ? true : false}
                />
            );
        }

        return returnValue;
    });

    return (
        <SidenavRoot {...rest} variant="permanent" ownerState={{ darkSidenav, miniSidenav, layout }}>
            <ArgonBox pt={3} pb={1} px={4} textAlign="center">
                <ArgonBox
                    display={{ xs: "block", xl: "none" }}
                    position="absolute"
                    top={0}
                    right={0}
                    p={1.625}
                    onClick={closeSidenav}
                    sx={{ cursor: "pointer" }}
                >
                    <ArgonTypography variant="h6" color="secondary">
                        <Icon sx={{ fontWeight: "bold" }}>close</Icon>
                    </ArgonTypography>
                </ArgonBox>
                <ArgonBox component={NavLink} to="/" display="flex" alignItems="center">
                    {brand && (
                        <ArgonBox component="img" src={brand} alt="Argon Logo" width="2rem" mr={0.25} />
                    )}
                    <ArgonBox
                        width={!brandName && "100%"}
                        sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
                    >
                        <ArgonTypography
                            component="h6"
                            variant="button"
                            fontWeight="medium"
                            color={darkMode ? darkSidenav && "white" : darkSidenav ? "white" : "dark"}
                        >
                            {brandName}
                        </ArgonTypography>
                    </ArgonBox>
                </ArgonBox>
            </ArgonBox>
            <Divider light={darkMode ? !darkSidenav : darkSidenav} />
            <List>{renderRoutes}</List>
        </SidenavRoot>
    );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
    color: "info",
    brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
    brand: PropTypes.string,
    brandName: PropTypes.string.isRequired,
    routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
